import { useQueryResourceList } from './useQueryResourceList.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryFolders = (parentId, queryOptions) => {
  const { resources, ...query } = useQueryResourceList({
    parentId,
    /**
    * @TODO
    * no consumer handles lazy fetching, so we need to set high limit
    * https://linear.app/futurebrowser/issue/FUT-4935/usequeryfolders-now-fetching-up-to-200-items-need-to-check-consumers
    */
    limit: 200,
    kind: [
      "folder"
    ]
  }, {
    ...queryOptions,
    enabled: isQueryEnabled([
      queryOptions?.enabled,
      !!parentId
    ])
  });
  return {
    ...query,
    folders: resources
  };
};

export { useQueryFolders };
//# sourceMappingURL=useQueryFolders.js.map
